import { Component } from '@angular/core';

@Component({
	selector: 'cc-quoting-widget',
	templateUrl: './quoting-widget.component.html',
	styleUrls: ['./quoting-widget.component.css']
})
export class QuotingWidgetComponent {

	public NewQuotes: number = 5;

	public PendingQuotes: number = 4;

	public RejectQuotes: number = 1;

// #region [ Public Methods ]

	/**
	 * Gets the class names to be used for navigation items.
	 *
	 * @param Page The navigation section querying it's CSS.
	 * @returns A JSON object with the CSS class names to use.
	 */
	public GetNumberClassNames(ShowGreaterThanZeroAsRed: boolean, Number: number): object {
		return {
			"QuoteNumber": true,
			"Green": (!ShowGreaterThanZeroAsRed && Number > 0),
			"Red": (ShowGreaterThanZeroAsRed && Number > 0)
		};
	}

// #endregion

}